<template>
    <!-- «Наріж піцу»: кожен по черзі 5 секунд якомога швидше тицяє в піцу, кожен дотик — розріз.
         Найменше розрізів — платить; однаково — жереб -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="state == 'done'">Найменше розрізів: <b>{{ players[loser] }}</b>!</template>
            <template v-else>Ріже <b>{{ players[current] }}</b></template>
        </p>
        <button type="button" class="bp-wp-cut" :class="'is-' + state" :disabled="state == 'done' || state == 'shown'"
                @pointerdown.prevent="hit()" @keydown.enter.prevent="hit()" @keydown.space.prevent="hit()">
            <img v-if="photo" :src="photo" alt="" class="bp-wp-cut__img">
            <span v-else class="bp-wp-cut__base"></span>
            <span v-for="cut in cuts" :key="cut.n" class="bp-wp-cut__line" :style="{ transform: 'rotate(' + cut.a + 'deg)' }"></span>
            <span class="bp-wp-cut__label">
                <template v-if="state == 'ready'">Тисни, щоб почати</template>
                <template v-else-if="state == 'count'">{{ count }}</template>
                <template v-else>{{ hits }}</template>
            </span>
        </button>
        <div class="bp-wp-cutbar" v-if="state == 'go'"><span :style="{ width: left * 100 + '%' }"></span></div>
        <p class="bp-wp-hint" v-else>{{ hint }}</p>
        <ol class="bp-wp-board">
            <li v-for="(name, i) in players" :key="i" :class="{ 'is-now': state != 'done' && i == current, 'is-lose': state == 'done' && i == loser }">
                <span class="bp-wp-board__name">{{ name }}</span>
                <span class="bp-wp-board__val">{{ score[i] != null ? score[i] : '—' }}</span>
            </li>
        </ol>
    </div>
</template>

<script>
const ROUND_MS = 5000;
const cutsWord = n => { const m = n % 100, d = n % 10; return m > 10 && m < 20 ? 'розрізів' : d == 1 ? 'розріз' : d >= 2 && d <= 4 ? 'розрізи' : 'розрізів'; };

export default {
    name: 'GameTap',
    props: {
        players: { type: Array, required: true },
        photo: { type: String, default: '' }
    },
    data() {
        return {
            current: 0,
            state: 'ready',
            count: 3,
            hits: 0,
            cuts: [],
            left: 1,
            score: this.players.map(() => null),
            loser: null,
            timer: null,
            raf: null,
            t0: 0,
            hint: '5 секунд: тицяйте в піцу якомога швидше'
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearTimeout(this.timer);
        cancelAnimationFrame(this.raf);
    },
    methods: {
        hit() {
            if (this.state == 'ready') return this.countdown();
            if (this.state != 'go') return;
            this.hits++;
            // На піці лишаємо до 24 ліній розрізу — далі лише лічильник
            if (this.cuts.length < 24) this.cuts.push({ n: this.hits, a: Math.round(Math.random() * 180) });
        },
        countdown() {
            this.state = 'count';
            this.count = 3;
            this.timer = setInterval(() => {
                this.count--;
                if (this.count > 0) return;
                clearInterval(this.timer);
                this.start();
            }, 700);
        },
        start() {
            this.state = 'go';
            this.hits = 0;
            this.cuts = [];
            this.t0 = performance.now();
            const loop = () => {
                const rest = 1 - (performance.now() - this.t0) / ROUND_MS;
                this.left = Math.max(0, rest);
                if (rest > 0) { this.raf = requestAnimationFrame(loop); return; }
                this.end();
            };
            loop();
        },
        end() {
            const who = this.current;
            this.$set(this.score, who, this.hits);
            if (who < this.players.length - 1) {
                this.state = 'shown';
                this.hint = this.hits + ' ' + cutsWord(this.hits) + '. Передайте телефон: ' + this.players[who + 1];
                this.timer = setTimeout(() => { this.current++; this.cuts = []; this.hits = 0; this.state = 'ready'; }, 1600);
                return;
            }
            const min = Math.min(...this.score);
            const tied = this.players.map((_, i) => i).filter(i => this.score[i] === min);
            this.loser = tied[Math.floor(Math.random() * tied.length)];
            this.state = 'done';
            setTimeout(() => this.$emit('done', { loser: this.loser, note: min + ' ' + cutsWord(min) + ' за 5 секунд' }), 1300);
        }
    }
}
</script>
